import React, { useEffect, useState } from 'react';

import { Block, withBlockRendering } from './Block.jsx';
import { Builder, EditorContainer, EditorContainerWrapper, PageBottomHiddenDraggable, PageTopHiddenDraggable } from '../layout/Builder.jsx';
import { Clickable } from './Button.jsx';
import Defaults from '../layout/Defaults.jsx';
import { withValidationV2 } from './Form.jsx';
import { default as _Image } from './Image.jsx';
import { Required, Wrapper as InputWrapper } from './Input.jsx';
import { Subtitle } from './Inventory.jsx';
import { ButtonType as InventoryCTAButtonType } from '../block/InventoryCTA.jsx';
import LocalStorage from './LocalStorage.jsx';
import Name from './Name.jsx';
import PageType from './PageType.jsx';
import { SlideshowDot, withSlideshowInitialization } from './Slideshow.jsx';
import Utilities from './Utilities.jsx';

function BackgroundOverlay(props) {
    let opacity = 1;
    let zIndex = 20;
    return (
        <div className="" style={{ cursor: 'pointer', opacity: opacity, zIndex: zIndex }} onClick={props.onClick} />
    );
}

function CloseButton(props) {
    const className = props.className || 'ol__close';
    let content;
    switch (props.type) {
        case 'outline':
            content = <span className="i i-outline-close" />;
            break;
        default:
            content = (
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 357 357">
                    <path d="M357 35.7L321.3 0 178.5 142.8 35.7 0 0 35.7l142.8 142.8L0 321.3 35.7 357l142.8-142.8L321.3 357l35.7-35.7-142.8-142.8"></path>
                </svg>
            );
            break;
    }
    return (
        <button className={className} style={{ cursor: 'pointer' }} onClick={props.onClick}>
            {content}
        </button>
    );
}

function ContentContainer(props) {
    const contentConfig = props.contentConfig || {};
    const mode = props.mode || 'desktop';
    let blocks = [];
    let containerProps;
    if (contentConfig[mode] && contentConfig[mode].blocks) {
        blocks = contentConfig[mode].blocks;
        containerProps = contentConfig[mode].page;
    }
    const handleBlockProps = (d) => {
        if (!d.type) {
            return;
        }
        let blockProps = {};
        if (props.blockPropsHandler) {
            blockProps = props.blockPropsHandler(d) || {};
        }
        switch (d.type.value) {
            case Name.Block.CloseButton:
                blockProps.type = 'outline';
                blockProps.onClick = blockProps.onClick || props.onClose
                break;
        }
        blockProps.inPopup = true;
        return blockProps;
    }
    let className = 'ol--modal--whitelabel';
    let containerStyle = {};
    Utilities.copyObject(props.style, containerStyle);
    let handleBuilderBlockProps;
    if (props.builder) {
        handleBuilderBlockProps = Builder.handleBlockProps
        // handleBuilderBlockProps = (d, blockConfig, parentProps) => {
        //     const blockProps = Builder.handleBlockProps(d, blockConfig, parentProps) || {};
        //     if (!d.type) {
        //         return blockProps;
        //     }
        //     // switch (d.type.value) {
        //     // }
        //     return blockProps;
        // }
        if (!props.editor) {
            containerStyle.pointerEvents = 'none';
        }
    } else {
        className = `ol--share__modal ${className}`;
    }
    const handleMapStyleConfigComplete = (style) => {
        const _style = style || {};
        if (_style.maxWidth && _style.maxWidth.length > 0) {
            _style.width = '100%';
        }
        return _style;
    }
    let content = (
        <EditorContainer
            {...props}
            blockPropsHandler={handleBlockProps}
            blocks={blocks}
            builderBlockPropsHandler={handleBuilderBlockProps}
            className={className}
            containerProps={containerProps}
            style={containerStyle}
            onContainerProps={props.onPageProps}
            onMapStyleConfigComplete={handleMapStyleConfigComplete} />
    );
    if (!props.builder && !props.editor) {
        let className = 'ol--share';
        if (props.className) {
            className += ` ${props.className}`;
        }
        content = <div className={className}>{content}</div>
    }
    return content;
}

function Popup(props) {
    let className = 'ol__cont ol--active';
    if (props.className) {
        className += ` ${props.className}`;
    }
    let backgroundClickHandler;
    if (props.backgroundClick != false) {
        backgroundClickHandler = props.onClose;
    }
    return (
        <React.Fragment>
            <BackgroundOverlay onClick={backgroundClickHandler} />
            <div className={className}>
                <CloseButton onClick={props.onClose} />
                {props.children}
            </div>
        </React.Fragment>
    )
}

// #region IMAGE GALLERY

function ImageGalleryModal(props) {

    // PROPS
    // activeIndex: number
    // builder: typeof builder
    // data: {
    //    id: string;
    //    caption: string;
    //    extension: string;
    // }[]  
    // onClose: () => void;

    const data = props.data || [];
    const [activeIndex, setActiveIndex] = useState(props.activeIndex);
    const handleUpdateActiveIndex = delta => setActiveIndex((activeIndex + data.length + delta) % data.length);
    return (
        <Popup backgroundClick={false} className="ol--ig modal" onClose={props.onClose}>
            <Clickable className="ol__prev" onClick={() => { handleUpdateActiveIndex(-1) }}><span className="i i-arrow-left" /></Clickable>
            <Clickable className="ol__next" onClick={() => { handleUpdateActiveIndex(1) }}><span className="i i-arrow-right" /></Clickable>
            <ImageGallerySlide builder={props.builder} config={props.config} data={data[activeIndex]} />
        </Popup>
    );
}

function ImageGallerySlide(props) {
    let src
    const imageData = props.data.image || { id: props.data.id, extension: props.data.extension };
    const index = _Image.sizes.length - 1;
    const srcSet = _Image.sizes.map(function (d, i) {
        if (i == index) {
            src = _Image.url(imageData, d, d, 'c_fit');
        }
        return `${_Image.url(imageData, d, d, 'c_fit')} ${d}w`;
    });
    const imageRef = React.useRef(undefined);
    React.useEffect(() => {
        if (!imageRef || !imageRef.current) {
            return;
        }
        imageRef.current.className = 'lazyload'
    }, [props.data.id])
    let imageStyle;
    if (!props.builder && !props.config.canDownloadImages) {
        imageStyle = { pointerEvents: 'none' };
    }
    return (
        <React.Fragment>
            <div className="ol--ig__img">
                <img ref={imageRef}
                    alt={props.data.caption}
                    className="lazyload"
                    data-sizes="auto"
                    data-src={src}
                    data-srcset={srcSet ? srcSet.join(', ') : undefined}
                    src={src}
                    style={imageStyle} />
            </div>
            {
                props.data.caption &&
                <div className="ol--ig__meta" dangerouslySetInnerHTML={{ __html: props.data.caption }}></div>
            }
        </React.Fragment>
    );
}

// #endregion IMAGE GALLERY

// #region INVENTORY

function _InventoryModal(props) {
    const [scrollOffset, setScrollOffset] = React.useState(0);
    React.useEffect(() => {
        if (props.builder) {
            return;
        }
        setScrollOffset(window.scrollY);
        document.body.style.overflow = 'hidden';
        return () => {
            window.screenY = scrollOffset;
            document.body.style.overflow = 'auto';
        }
    }, [])

    // Current Inventory Data
    const data = props.data || [];
    const [activeIndex, setActiveIndex] = React.useState(undefined);
    const handleUpdateActiveIndex = function (delta) {
        setActiveIndex(undefined);
        const index = (activeIndex + data.length + delta) % data.length;
        setTimeout(() => setActiveIndex(index), 10);
    }
    React.useEffect(() => {
        for (let i = 0; i < data.length; i++) {
            if (data[i].id != props.inventoryId) {
                continue;
            }
            setActiveIndex(i);
            break;
        }
    }, []);
    let inventory;
    if (props.builder) {
        inventory = props.data && props.data.inventory;
    } else if (activeIndex < data.length) {
        inventory = data[activeIndex];
    }
    React.useEffect(() => {
        if (props.builder || !inventory) {
            return;
        }
        LocalStorage.RecentlyViewed.put(inventory);
    }, [inventory]);

    // Content Properties
    let className = 'ol__cont ol--active ol--aw modal cont--whitelabel';
    if (props.builder) {
        className += ' builder';
    }
    const contentProps = {
        className,
        id: props.id,
        onDragOver: (e) => { if (e) { e.preventDefault() } },
        onDrop: props.onDrop
    }
    let pageConfig = props.contentConfig || props.pageConfig;
    if (!props.builder && !pageConfig) {
        pageConfig = Defaults.PageConfig[PageType.InventoryDetailModal](props.config);
    }
    let containerProps;
    if (props.onPageProps) {
        containerProps = props.onPageProps();
    } else if (pageConfig.desktop) {
        containerProps = pageConfig.desktop.page;
    }

    // Block Config Style Parsing
    const arrowLeftStyle = {};
    const arrowRightStyle = {};
    if (props.builder) {
        arrowLeftStyle.pointerEvents = 'none';
        arrowLeftStyle.position = 'fixed';
        arrowRightStyle.pointerEvents = 'none';
        arrowRightStyle.position = 'fixed';
    }
    const style = { height: '100%', overflow: 'auto' }
    let scrollable, topHiddenOffset;
    if (containerProps && containerProps.config) {
        let configProps;
        for (let configName in containerProps.config) {
            configProps = containerProps.config[configName];
            Block.mapStyleConfigProps(style, configProps, (propName, propValue, propUnit) => {
                switch (propName) {
                    case 'arrowColor':
                        arrowLeftStyle.color = propValue;
                        arrowRightStyle.color = propValue;
                        break;
                    case 'arrowOffset': {
                        if (!propValue || !propUnit) {
                            return true;
                        }
                        const value = `${propValue}${propUnit}`;
                        arrowLeftStyle.left = value;
                        arrowRightStyle.right = value;
                        return true;
                    }
                    case 'arrowSize': {
                        if (!propValue || !propUnit) {
                            return true;
                        }
                        const value = `${propValue}${propUnit}`;
                        arrowLeftStyle.fontSize = value;
                        arrowRightStyle.fontSize = value;
                        return true;
                    }
                    case 'paddingTop':
                        topHiddenOffset = propValue;
                        break;
                    case 'scrollable':
                        scrollable = propValue;
                        return true;
                }
            });
        }
    }

    // Block Rendering
    let blocks = [];
    if (pageConfig.desktop && pageConfig.desktop.blocks) {
        blocks = pageConfig.desktop.blocks;
    }
    const backgroundColor = style.backgroundColor || props.config && props.config.colors && props.config.colors.bodyBackground;
    let renderedBlocks = props.onBlockRendering(
        props.pageType,
        blocks,
        (d) => {
            if (!d.type) {
                return;
            }
            const blockProps = { backgroundColor };
            switch (d.type.value) {
                case Name.Block.CloseButton:
                    blockProps.onClick = props.onClose;
                    break;
                case Name.Block.Inventory.Button.InquireV1:
                case Name.Block.Inventory.Button.InquireV2:
                case Name.Block.Inventory.Button.InquireV3:
                case Name.Block.Inventory.Button.OfferV1:
                case Name.Block.Inventory.Button.OfferV2:
                case Name.Block.Inventory.Button.OfferV3:
                case Name.Block.Inventory.Button.PurchaseV1:
                case Name.Block.Inventory.Button.PurchaseV2:
                case Name.Block.Inventory.Button.PurchaseV3:
                    const buttonType = InventoryCTAButtonType.fromBlockConfig(d);
                    switch (buttonType) {
                        case InventoryCTAButtonType.Inquire:
                            blockProps.onButtonClick = () => props.onInquire(inventory);
                            break;
                        case InventoryCTAButtonType.Offer:
                            blockProps.onButtonClick = () => props.onOffer(inventory);
                            break;
                        case InventoryCTAButtonType.Purchase:
                            blockProps.onButtonClick = () => props.onPurchase(inventory);
                    }
                    break;
                case Name.Block.Inventory.Image:
                    blockProps.useVH = true;
                    break;
            }
            return blockProps;
        },
        (d, blockConfig, parentProps) => {
            let blockProps;
            if (props.builderBlockPropsHandler) {
                blockProps = props.builderBlockPropsHandler(d, blockConfig, parentProps)
            }
            if (!d.type) {
                return blockProps;
            }
            if (!blockProps) {
                blockProps = {};
            }
            if (!blockProps.style) {
                blockProps.style = {};
            }
            switch (d.type.value) {
                case Name.Block.Columns:
                    if (blockConfig && blockConfig.layout) {
                        if (blockConfig.layout.position == 'fixed') {
                            let bottom;
                            if (blockConfig.layout.bottom && blockConfig.layout.bottom.value && blockConfig.layout.bottom.value.length > 0 && blockConfig.layout.bottom.unit) {
                                bottom = `${blockConfig.layout.bottom.value}${blockConfig.layout.bottom.unit}`;
                            }
                            let top;
                            if (blockConfig.layout.top && blockConfig.layout.top.value && blockConfig.layout.top.value.length > 0 && blockConfig.layout.top.unit) {
                                top = `${blockConfig.layout.top.value}${blockConfig.layout.top.unit}`;
                            }
                            let zIndex;
                            switch (blockConfig.layout.zIndex) {
                                case '-1':
                                    zIndex = '0';
                                    break;
                                default:
                                    zIndex = '2';
                            }
                            blockProps.style.bottom = bottom;
                            blockProps.style.position = 'fixed';
                            blockProps.style.top = top;
                            blockProps.style.width = 'calc(100% - 8px)';
                            blockProps.style.zIndex = zIndex;
                        }
                    }
                    break;
                case Name.Block.Inventory.Image:
                    blockProps.style.zIndex = '1';
                    break;
                default:
                    blockProps.style.zIndex = '1';
                    break;
            }
            return blockProps;
        },
        { inventory }
    );

    let content = renderedBlocks;
    if (!scrollable) {
        let height = '100%';
        if (props.builder) {
            style.height = 'calc(100vh - 34px)';
            height = 'calc(100% + 32px)';
        } else {
            style.height = '100vh';
        }
        style.overflow = 'hidden';
        style.width = props.editor ? 'calc(100vw - 8px)' : '100vw';
        content = <div style={{ display: 'flex', flexDirection: 'column', height }}>{content}</div>
    }
    content = (
        <React.Fragment>
            <BackgroundOverlay />
            <div style={style}>
                {
                    props.editor &&
                    <PageTopHiddenDraggable offset={topHiddenOffset} pageEmpty={!renderedBlocks || renderedBlocks.length == 0} onDragEnter={props.onDragEnter} />
                }
                <Clickable className="ol__arrow ol__prev" style={arrowLeftStyle} onClick={() => { handleUpdateActiveIndex(-1) }}><span className="i i-arrow-left" /></Clickable>
                <Clickable className="ol__arrow ol__next" style={arrowRightStyle} onClick={() => { handleUpdateActiveIndex(1) }}><span className="i i-arrow-right" /></Clickable>
                {inventory != undefined && content}
                {
                    props.editor &&
                    <PageBottomHiddenDraggable onDragEnter={props.onDragEnter} />
                }
            </div>
        </React.Fragment>
    );
    if (props.editor) {
        return <EditorContainerWrapper {...contentProps}>{content}</EditorContainerWrapper>
    }
    return <div {...contentProps}>{content}</div>
}
const InventoryModal = withBlockRendering(_InventoryModal);

// #endregion INVENTORY

// #region SHARE

function ShareModal(props) {
    const [pane, setPane] = useState('share');
    const inventory = props.inventory || {};
    const seoDescription = props.pageConfig && props.pageConfig.seoDesc;

    useEffect(() => {
        if (window && window.gtag) {
            gtag('event', 'share-modal', {
                'title': props.inventory.title
            });
        }
    }, []);

    let facebookUrl, pinterestUrl;
    if (window && window.location) {
        const encodedUrl = encodeURIComponent(window.location.href);
        facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`
        pinterestUrl = `https://www.pinterest.com/pin/create/button/?url=${encodedUrl}`;

        const images = inventory.images;
        if (images && images.length > 0) {
            const imageUrl = _Image.url(images[0], undefined, 1920);
            if (imageUrl) {
                pinterestUrl += `&media=${encodeURIComponent(imageUrl)}`;
            }
        }
        if (seoDescription) {
            pinterestUrl += `&description=${encodeURIComponent(props.pageConfig.seoDesc)}`;
        }
    }
    return (
        <div className="ol--share ol--social">
            {
                pane == 'share' &&
                <div className="ol--share__modal--main ol--share__modal">
                    <CloseButton className="ol--share__close" type="outline" onClick={props.onClose} />
                    <div className="typ--main typ--main--modal">
                        <div className="typ--main__inn">
                            Share
                            {
                                inventory.artist &&
                                inventory.artist.name &&
                                <h2 className="artwork__artist">{inventory.artist.name}</h2>
                            }
                            <div>
                                <span className="artwork__title">{inventory.title}</span><Subtitle data={inventory} />
                            </div>
                        </div>
                    </div>
                    <div className="ol--share__inn">
                        <a className="social__anch"
                            data-pin-do="buttonPin"
                            data-pin-custom="true"
                            href={pinterestUrl}
                            target="_blank">
                            <span className="i i-pint" />
                        </a>
                        <a className="fb-xfbml-parse-ignore social__anch" href={facebookUrl} target="_blank">
                            <span className="i i-fcbk" />
                        </a>
                        <Clickable className="social__anch" id="mail" onClick={setPane}><span className="i i-mail" /></Clickable>
                        <Clickable className="social__anch" id="sms" onClick={setPane}><span className="i i-chat" /></Clickable>
                    </div>
                </div>
            }
            {
                pane == 'mail' &&
                <ShareEmailPane
                    description={seoDescription}
                    id={inventory.id}
                    sub={props.sub}
                    onBack={setPane}
                    onClose={props.onClose} />
            }
            {
                pane == 'sms' &&
                <ShareSMSPane
                    description={seoDescription}
                    id={inventory.id}
                    sub={props.sub}
                    onBack={setPane}
                    onClose={props.onClose} />
            }
        </div>
    );
}

function _ShareEmailPane(props) {
    React.useEffect(() => {
        if (!props.formData.token) {
            return;
        }
        const postData = {
            Email: props.formData.Email,
            InventoryId: props.id,
            Robots: props.formData.token,
            Sub: props.sub
        };
        props.onSubmit('/api/shares/email', postData);
    }, [props.formData.token])
    const buttonClassName = props.formData.formState != undefined ? ` btn--${props.formData.formState}` : ''
    let content = (
        <div className="ol--share__modal--mail ol--share__modal">
            <Clickable className="ol--share__back" id="share" onClick={props.onBack}><span className="i i-arrow-left" /></Clickable>
            <CloseButton className="ol--share__close" type="outline" onClick={props.onClose} />
            <h1 className="typ--main typ--main--modal">
                <div className="typ--main__inn">Share {props.description}</div>
            </h1>
            <form className="form form--mail" id="mailForm">
                <InputWrapper className="m-b-sm" size="large">
                    <Required
                        disabled={props.disabled}
                        errors={props.formData.errors}
                        name="Email"
                        placeholder="Email Address"
                        type="email"
                        value={props.formData.Email}
                        onChange={props.onChange} />
                </InputWrapper>
                <div className="form--contact__foot">
                    <Clickable
                        className={`btn btn--fill${buttonClassName}`}
                        disabled={props.disabled}
                        type="submit"
                        onClick={props.onValidate}>
                        <React.Fragment><div className="submission-status"></div> {props.formData.formState == 'success' ? 'Shared' : 'Send Email'}</React.Fragment>
                    </Clickable>
                </div>
            </form>
        </div>
    );
    if (props.onContent) {
        content = props.onContent(content)
    }
    return content;
}
const ShareEmailPane = withValidationV2(_ShareEmailPane, ['Email']);

function _ShareSMSPane(props) {
    React.useEffect(() => {
        if (!props.formData.token) {
            return;
        }
        const postData = {
            InventoryId: props.id,
            Phone: props.formData.Phone,
            Robots: props.formData.token,
            Sub: props.sub
        };
        props.onSubmit('/api/shares/sms', postData);
    }, [props.formData.token])
    const buttonClassName = props.formData.formState != undefined ? ` btn--${props.formData.formState}` : ''
    let content = (
        <div className="ol--share__modal--sms ol--share__modal">
            <Clickable className="ol--share__back" id="share" onClick={props.onBack}><span className="i i-arrow-left" /></Clickable>
            <CloseButton className="ol--share__close" type="outline" onClick={props.onClose} />
            <h1 className="typ--main typ--main--modal">
                <div className="typ--main__inn">Share {props.description}</div>
            </h1>
            <form className="form form--sms" id="smsForm">
                <InputWrapper className="m-b-sm" size="large">
                    <Required
                        disabled={props.disabled}
                        errors={props.formData.errors}
                        name="Phone"
                        placeholder="Phone Number"
                        value={props.formData.Phone}
                        onChange={props.onChange} />
                </InputWrapper>
                <div className="form--contact__foot">
                    <Clickable
                        className={`btn btn--fill${buttonClassName}`}
                        disabled={props.disabled}
                        type="submit"
                        onClick={props.onValidate}>
                        <React.Fragment><div className="submission-status"></div> {props.formData.formState == 'success' ? 'Shared' : 'Send SMS'}</React.Fragment>
                    </Clickable>
                </div>
            </form>
        </div>
    );
    if (props.onContent) {
        content = props.onContent(content)
    }
    return content;
}
const ShareSMSPane = withValidationV2(_ShareSMSPane, ['Phone']);

// #endregion SHARE

// #region VIRTUAL INSTALL

const VirtualInstallMousePosition = {
    Artwork: 'artwork',
    Guide: 'guide',
    GuideLeftHandle: 'guideLeftHandle',
    GuideRightHandle: 'guideRightHandle'
}
class VirtualInstallModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            // room state
            canvasHeight: 0,
            canvasWidth: 0,
            imageHref: '#',
            selectedFile: '../images/room.jpg',
            loading: true,
            isVertical: undefined,

            // artwork state
            active: false,
            artworkHeight: 0,
            artworkWidth: 0,
            currentX: 0,
            currentY: 0,
            initialX: 0,
            initialY: 0,

            // guide state
            guideActive: false,
            guideVisible: true,
            guideLeftHandleActive: false,
            guideRightHandleActive: false,
            guideInitialX: 0,
            guideInitialWidth: 0,
            guideWidthInput: 0,
            guideWidthUnit: '',
            guideCurrentWidth: 0,
            guideCurrentX: 0,
            guideCurrentY: 0,
            activateGuide: false
        };

        this._guideLeftHandleRect = this._guideLeftHandleRect.bind(this);
        this._guideRightHandleRect = this._guideRightHandleRect.bind(this);

        this.checkImage = this.checkImage.bind(this);
        this.drawRoom = this.drawRoom.bind(this);
        this.drawRoomWithNewArtworkSize = this.drawRoomWithNewArtworkSize.bind(this);
        this.getMousePosition = this.getMousePosition.bind(this);
        this.getInitialDimensions = this.getInitialDimensions.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleFileChange = this.handleFileChange.bind(this);
        this.handleGuidePopupClose = this.handleGuidePopupClose.bind(this);
        this.handleGuideWidthInputChange = this.handleGuideWidthInputChange.bind(this);
        this.handleMouseDown = this.handleMouseDown.bind(this);
        this.handleMouseUp = this.handleMouseUp.bind(this);
        this.handleMouseMove = this.handleMouseMove.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.loadImgs = this.loadImgs.bind(this);

        this.canvasRef = React.createRef(null);
        this.downloadRef = React.createRef(null);
        this.screenRef = React.createRef(null);

        this.artwork = new Image();
        this.ctx = {};
        this.defaultDimensions = { width: 36, height: 36, metric: { value: 0 } };
        this.room = new Image();
    }

    componentDidMount() {
        // init canvas
        const canvas = this.canvasRef.current;
        this.ctx = canvas.getContext("2d");

        // add room image
        const roomPathAndElem = [this.state.selectedFile, this.room];

        // add artwork image
        const artworkPathAndElem = [this.props.image ? `${window.location.origin}/img?path=${this.props.image}&sub=${this.props.sub}` : undefined, this.artwork];

        this.loadImgs(roomPathAndElem, artworkPathAndElem).then(() => {
            this.getInitialDimensions(this.drawRoom);
        });

        if (window && window.gtag) {
            gtag('event', 'virtual-install-modal', {
                'title': this.props.data.Title
            });
        }
    }

    _guideLeftHandleRect() {
        return { bottom: this.state.guideCurrentY + 15, left: this.state.guideCurrentX - 7, right: this.state.guideCurrentX + 7, top: this.state.guideCurrentY - 15 };
    }

    _guideRightHandleRect() {
        return {
            bottom: this.state.guideCurrentY + 15,
            left: this.state.guideCurrentX + this.state.guideCurrentWidth - 7,
            right: this.state.guideCurrentX + this.state.guideCurrentWidth + 7,
            top: this.state.guideCurrentY - 15
        };
    }

    checkImage(path, elem) {
        return new Promise((resolve, reject) => {
            elem.onload = (e) => {
                resolve({ path, status: 'ok' });
            };
            elem.onerror = (e) => {
                reject({ path, status: 'error' });
            }
            elem.src = path;
        });
    }

    drawRoom() {
        const {
            artworkWidth, canvasWidth, canvasHeight,
            currentX, currentY, guideCurrentWidth, guideCurrentX, guideCurrentY,
            guideVisible
        } = this.state;

        // draw room
        this.ctx.drawImage(this.room, 0, 0, canvasWidth, canvasHeight);

        if (guideVisible) {
            // draw rounded guide background
            const radius = 7;
            const rectX = guideCurrentX - 7;
            const rectY = guideCurrentY - 30;
            const rectW = guideCurrentWidth + 14;
            const rectH = 44;


            this.ctx.beginPath();
            this.ctx.moveTo(rectX + radius, rectY);
            this.ctx.lineTo(rectX + rectW - radius, rectY);
            this.ctx.quadraticCurveTo(rectX + rectW, rectY, rectX + rectW, rectY + radius);
            this.ctx.lineTo(rectX + rectW, rectY + rectH - radius);
            this.ctx.quadraticCurveTo(rectX + rectW, rectY + rectH, rectX + rectW - radius, rectY + rectH);
            this.ctx.lineTo(rectX + radius, rectY + rectH);
            this.ctx.quadraticCurveTo(rectX, rectY + rectH, rectX, rectY + rectH - radius);
            this.ctx.lineTo(rectX, rectY + radius);
            this.ctx.quadraticCurveTo(rectX, rectY, rectX + radius, rectY);
            this.ctx.closePath();
            this.ctx.fillStyle = 'rgba(0,0,0,.5)';
            this.ctx.strokeStyle = 'rgba(0,0,0,.5)';
            this.ctx.fill();

            // draw guide
            this.ctx.beginPath();

            // span line 
            this.ctx.moveTo(guideCurrentX, guideCurrentY);
            this.ctx.lineTo(guideCurrentX + guideCurrentWidth, guideCurrentY);

            // left handle
            this.ctx.moveTo(guideCurrentX, guideCurrentY - 7);
            this.ctx.lineTo(guideCurrentX, guideCurrentY + 7);

            // right handle
            this.ctx.moveTo(guideCurrentX + guideCurrentWidth, guideCurrentY - 7);
            this.ctx.lineTo(guideCurrentX + guideCurrentWidth, guideCurrentY + 7);

            this.ctx.strokeStyle = '#fff';
            this.ctx.stroke();

            // add input width
            this.ctx.font = "20px Roboto";
            this.ctx.fillStyle = "#fff";
            this.ctx.fillText(
                this.state.guideWidthInput.toString() + ' ' + this.state.guideWidthUnit,
                guideCurrentX - 20 + guideCurrentWidth / 2,
                guideCurrentY - 7
            );
        }

        // add shadow and draw artwork
        this.ctx.shadowColor = 'rgba(0,0,0,.25)';
        this.ctx.shadowBlur = 5;
        this.ctx.shadowOffsetX = -5;
        this.ctx.shadowOffsetY = 5;

        // The original aspect ratio of the uploaded image is respected to the 
        // avoid distortion. It is assumed that the upload images are approximately
        // the same aspect ratio as the dimensions of original the artwork
        this.ctx.drawImage(this.artwork, currentX, currentY, artworkWidth, artworkWidth * (this.artwork.height / this.artwork.width));
    }

    drawRoomWithNewArtworkSize() {
        const dimensions = this.props.data.Dimensions || this.defaultDimensions;
        const {
            guideCurrentWidth, guideWidthInput, currentX, currentY,
            artworkWidth, artworkHeight
        } = this.state;

        const newArtworkWidth = dimensions.width * guideCurrentWidth / guideWidthInput;
        const newArtworkHeight = dimensions.height * guideCurrentWidth / guideWidthInput;
        const newArtworkX = currentX + ((artworkWidth - newArtworkWidth) / 2);
        const newArtworkY = currentY + ((artworkHeight - newArtworkHeight) / 2);

        this.setState({
            artworkWidth: newArtworkWidth,
            artworkHeight: newArtworkHeight,
            currentX: newArtworkX,
            currentY: newArtworkY
        }, this.drawRoom);
    }

    getInitialDimensions(callback) {
        // get art and screen dimensions
        const dimensions = this.props.data.Dimensions || this.defaultDimensions;
        const screenHeight = this.screenRef.current.clientHeight;
        const screenWidth = this.screenRef.current.clientWidth;
        const screenAspectRatio = screenWidth / screenHeight;

        // get constant / unit
        let conversionConstant, initialGuideWidthInput, unit;
        switch (dimensions.metric.value) {
            // inches
            case 0:
                conversionConstant = 1;
                unit = 'in';
                break;
            // cm
            case 1:
                conversionConstant = 2.54;
                unit = 'cm';
                break;
            // feet
            case 2:
                conversionConstant = (1 / 12);
                unit = 'ft'
                break;
            default:
                break;
        }
        // There are two possible guide lengths here: 84in (7ft) and 120in (10ft)
        // Artworks with less than 5.8ft height and 13ft width are given the 7ft guide
        // Artworks greater are given the 10ft guide
        // largest comfortably supported image is max 9ft height and max 19ft width
        if (dimensions.width >= (156 * conversionConstant) || dimensions.height >= (70 * conversionConstant)) {
            initialGuideWidthInput = 120 * conversionConstant;
        } else {
            initialGuideWidthInput = 84 * conversionConstant;
        }

        // get room size
        const roomAspectRatio = this.room.width / this.room.height;
        const isVertical = roomAspectRatio < screenAspectRatio;
        let roomWidth = 0;
        let roomHeight = 0;

        if (isVertical) {
            roomWidth = roomAspectRatio * screenHeight;
            roomHeight = screenHeight;
        } else {
            roomWidth = screenWidth;
            roomHeight = screenWidth / roomAspectRatio;
        }

        // get guide size
        const guideWidth = roomWidth / 2;
        const guideX = roomWidth / 4;
        const guideY = roomHeight * 3 / 4;

        // get artwork size
        const artworkWidth = dimensions.width * guideWidth / initialGuideWidthInput;
        const artworkHeight = dimensions.height * guideWidth / initialGuideWidthInput;
        const artworkX = roomWidth / 2 - artworkWidth / 2;
        const artworkY = roomHeight * 3 / 8 - artworkHeight / 2;

        this.setState({
            artworkHeight: artworkHeight,
            artworkWidth: artworkWidth,
            canvasWidth: roomWidth,
            canvasHeight: roomHeight,
            currentX: artworkX,
            currentY: artworkY,
            isVertical: isVertical,
            guideCurrentWidth: guideWidth,
            guideWidthInput: initialGuideWidthInput,
            guideWidthUnit: unit,
            guideCurrentX: guideX,
            guideCurrentY: guideY,
        }, callback);
    }

    getMousePosition(event) {
        const screenHeight = this.screenRef.current.clientHeight;
        const screenWidth = this.screenRef.current.clientWidth;

        const { currentX, currentY, artworkWidth, artworkHeight,
            canvasWidth, canvasHeight, isVertical, guideCurrentWidth,
            guideCurrentX, guideCurrentY } = this.state;

        const xCorrection = (screenWidth - canvasWidth) / 2;
        const yCorrection = (screenHeight - canvasHeight) / 2;

        let clientX = event.clientX ? event.clientX : event.touches[0].clientX;
        let clientY = event.clientY ? event.clientY : event.touches[0].clientY;

        clientX = isVertical ? clientX - xCorrection : clientX;
        clientY = isVertical ? clientY : clientY - yCorrection;

        if (clientX > currentX &&
            clientX < currentX + artworkWidth &&
            clientY > currentY &&
            clientY < currentY + artworkHeight) {
            return VirtualInstallMousePosition.Artwork;
        } else if (clientX > guideCurrentX + 7 &&
            clientX < guideCurrentX + guideCurrentWidth - 7 &&
            clientY > guideCurrentY - 25 &&
            clientY < guideCurrentY + 15) {
            return VirtualInstallMousePosition.Guide;
        } else {
            const leftHandleRect = this._guideLeftHandleRect();
            if (clientX > leftHandleRect.left &&
                clientX < leftHandleRect.right &&
                clientY > leftHandleRect.top &&
                clientY < leftHandleRect.bottom) {
                return VirtualInstallMousePosition.GuideLeftHandle;
            }
            const rightHandleRect = this._guideRightHandleRect();
            if (clientX > rightHandleRect.left &&
                clientX < rightHandleRect.right &&
                clientY > rightHandleRect.top &&
                clientY < rightHandleRect.bottom) {
                return VirtualInstallMousePosition.GuideRightHandle;
            }
        }
        return false;
    }

    handleClose(event) {
        if (event) {
            event.preventDefault();
        }
        if (this.props.onClose) {
            this.props.onClose();
        }
    }

    handleFileChange(event) {
        event.preventDefault();
        this.setState(
            {
                selectedFile: URL.createObjectURL(event.target.files[0]),
                loading: true,
                activateGuide: true,
                showGuidePopup: true
            },
            () => {
                const roomPathAndElem = [this.state.selectedFile, this.room];

                this.loadImgs(roomPathAndElem).then(() => {
                    this.getInitialDimensions(this.drawRoom);
                });
            }
        );
    }

    handleGuideWidthInputChange(event, drawRoom = true) {
        event.preventDefault();
        const guideWidth = parseInt(event.target.value);

        this.setState(
            {
                guideWidthInput: !Number.isNaN(guideWidth) && guideWidth > 0 ? guideWidth : ''
            },
            !Number.isNaN(guideWidth) && guideWidth > 0 && drawRoom ? this.drawRoomWithNewArtworkSize : null
        )
    }

    handleGuidePopupClose(event) {
        event.preventDefault();
        this.setState(
            {
                showGuidePopup: false
            },
            !Number.isNaN(this.state.guideWidthInput) && this.state.guideWidthInput > 0 ? this.drawRoomWithNewArtworkSize : null
        );
    }

    handleMouseDown(event) {
        /* initialX is something different in each context used purely for calculation.
            artwork, guide, guideLeftHandle: distance from left edge of window to room left
            guideRightHandle: distance from left edge of window to guide left handle
        */
        const clientX = event.clientX ? event.clientX : event.touches[0].clientX;
        const clientY = event.clientY ? event.clientY : event.touches[0].clientY;

        if (this.getMousePosition(event) === VirtualInstallMousePosition.Artwork) {
            this.setState({
                initialX: clientX - this.state.currentX,
                initialY: clientY - this.state.currentY,
                active: true
            });
        } else if (this.getMousePosition(event) === VirtualInstallMousePosition.Guide && this.state.activateGuide) {
            this.setState({
                initialX: clientX - this.state.guideCurrentX,
                initialY: clientY - this.state.guideCurrentY,
                guideActive: true
            });
        } else if (this.getMousePosition(event) === VirtualInstallMousePosition.GuideLeftHandle && this.state.activateGuide) {
            this.setState({
                initialX: clientX - this.state.guideCurrentX,
                guideInitialX: this.state.guideCurrentX,
                guideInitialWidth: this.state.guideCurrentWidth,
                guideLeftHandleActive: true
            });
        } else if (this.getMousePosition(event) === VirtualInstallMousePosition.GuideRightHandle && this.state.activateGuide) {
            this.setState({
                initialX: clientX - this.state.guideCurrentWidth,
                guideRightHandleActive: true
            });
        }
    }

    handleMouseUp(event) {
        if (this.state.active || this.state.guideActive || this.state.guideLeftHandleActive || this.state.guideRightHandleActive) {
            this.setState({
                active: false,
                guideActive: false,
                guideLeftHandleActive: false,
                guideRightHandleActive: false
            });
        }
    }

    handleMouseMove(event) {
        const clientX = event.clientX ? event.clientX : event.touches[0].clientX;
        const clientY = event.clientY ? event.clientY : event.touches[0].clientY;

        if (this.state.active) {
            this.setState({
                currentX: clientX - this.state.initialX,
                currentY: clientY - this.state.initialY
            }, this.drawRoom);
        } else if (this.state.guideActive) {
            this.setState({
                guideCurrentX: clientX - this.state.initialX,
                guideCurrentY: clientY - this.state.initialY
            }, this.drawRoom);
        } else if (this.state.guideLeftHandleActive) {
            const guideCurrentX = clientX - this.state.initialX;
            const rightHandleRect = this._guideRightHandleRect();
            if (guideCurrentX > rightHandleRect.left - 50) {
                return false;
            }
            this.setState({
                guideCurrentX,
                guideCurrentWidth: this.state.guideInitialWidth + this.state.initialX + this.state.guideInitialX - clientX
            }, this.drawRoomWithNewArtworkSize);
        } else if (this.state.guideRightHandleActive) {
            if (clientX - this.state.initialX < 57) {
                return false;
            }
            this.setState({
                guideCurrentWidth: clientX - this.state.initialX
            }, this.drawRoomWithNewArtworkSize);
        }
    }

    handleSave() {
        this.setState(
            {
                guideVisible: false
            },
            () => {
                this.drawRoom();
                var image = this.canvasRef.current
                    .toDataURL("image/png")
                    .replace("image/png", "image/octet-stream");

                this.setState(
                    {
                        imageHref: image,
                        guideVisible: true
                    },
                    this.drawRoom
                );
            }
        );
    }

    loadImgs(...pathsAndElems) {
        return Promise.all(
            pathsAndElems.map(
                pathAndElem => this.checkImage(...pathAndElem)
            )
        ).then(() => this.setState({ loading: false }));
    }

    render() {
        const data = this.props.data || {};

        return (
            <React.Fragment>
                <Popup className="ol--virtual-install" backgroundClick={false} onClose={this.handleClose}>
                    <div>
                        <div className="ol--virtual-install__controls">
                            {this.state.activateGuide && <React.Fragment>
                                <span className="ol--virtual-install__controls__label">Guide Width: </span>
                                <span className="ol--virtual-install__controls__input-container">
                                    <input
                                        className="ol--virtual-install__controls__input-container__input"
                                        type="text"
                                        value={this.state.guideWidthInput}
                                        onChange={this.handleGuideWidthInputChange} />
                                    <span
                                        className="ol--virtual-install__controls__input-container__unit">
                                        {this.state.guideWidthUnit}
                                    </span>
                                </span>
                            </React.Fragment>}
                            <label
                                htmlFor="file"
                                className="ol--virtual-install__controls__btn btn btn--fill">
                                Choose Background Image
                            </label>
                            <input
                                className="ol--virtual-install__controls__input--file"
                                name="file"
                                type="file"
                                id="file"
                                accept="image/*"
                                onChange={this.handleFileChange} />
                            <a
                                ref={this.downloadRef}
                                download={data.Title + '.png'}
                                href={this.state.imageHref}
                                className="ol--virtual-install__controls__btn btn btn--fill"
                                onClick={this.handleSave}>
                                Save
                            </a>
                        </div>
                        <div className="ol--virtual-install__view"
                            ref={this.screenRef}>
                            {this.state.loading && <div className="ol--virtual-install__view__loading">loading images ...</div>}
                            <canvas
                                style={{
                                    visibility: this.state.loading ? 'hidden' : 'visible',
                                    objectFit: 'contain'
                                }}
                                onMouseDown={this.handleMouseDown}
                                onTouchStart={this.handleMouseDown}
                                onMouseUp={this.handleMouseUp}
                                onTouchEnd={this.handleMouseUp}
                                onMouseMove={this.handleMouseMove}
                                onTouchMove={this.handleMouseMove}
                                width={this.state.canvasWidth}
                                height={this.state.canvasHeight}
                                id="virtual-install"
                                className="ol--virtual-install__view__canvas"
                                ref={this.canvasRef}>
                            </canvas>
                        </div>
                    </div>
                </Popup>
                {this.state.showGuidePopup &&
                    <Popup
                        className="ol--virtual-install__guide"
                        onClose={this.handleGuidePopupClose}
                        type='container'>
                        <div>
                            <h5 className="typ--main typ--main--modal">Set Surface Mounting Width</h5>
                            <p>
                                What is the physical width({this.state.guideWidthUnit}) of the mounting surface in this photo?
                            </p>

                            <span className="ol--virtual-install__controls__input-container">
                                <input
                                    className="ol--virtual-install__controls__input-container__input"
                                    type="text"
                                    value={this.state.guideWidthInput}
                                    onChange={event => this.handleGuideWidthInputChange(event, false)} />
                                <span
                                    className="ol--virtual-install__controls__input-container__unit">
                                    {this.state.guideWidthUnit}
                                </span>
                            </span>
                            <a
                                className="ol--virtual-install__controls__btn btn btn--fill"
                                onClick={this.handleGuidePopupClose}>
                                Set Width
                            </a>
                            <p>
                                After setting the width, move and resize the guide to the width of the mounting surface in the background image.
                            </p>
                        </div>
                    </Popup>
                }
            </React.Fragment>
        );
    }
}

// #endregion VIRTUAL INSTALL

// #region ZOOM

function ZoomModal(props) {
    const [active, setActive] = useState(false);
    useEffect(() => {
        setActive(true);
    }, []);
    useEffect(() => {
        window.acpanzoom = {
            instance: Panzoom(document.getElementsByClassName('panzoom__img')[0])
        };
    }, []);

    let imageStyle;
    if (!props.builder && !props.config.canDownloadImages) {
        imageStyle = { pointerEvents: 'none' };
    }
    const inventory = props.inventory || {};
    const images = inventory.images || [];
    const seoDescription = props.pageConfig && props.pageConfig.seoDesc;
    let content;
    if (images.length > 0) {
        if (props.showAllImages == false || images.length == 1) {
            const imageUrl = _Image.url(images[0], undefined, 1920);
            content = (
                <div className="panzoom__parent">
                    <div id="zoomImage" className="panzoom__img">
                        <img
                            alt={seoDescription}
                            caption={seoDescription}
                            description={inventory.notes}
                            src={imageUrl}
                            style={imageStyle}
                            title={seoDescription} />
                    </div>
                </div>
            );
        } else {
            content = (
                <ZoomSlideshow
                    blockIdentifier={`zoom-${props.blockIdentifier}`}
                    images={images}
                    imageStyle={imageStyle}
                    inventory={inventory}
                    seoDescription={seoDescription}
                    startPosition={props.index} />
            );
        }
    }
    let className = 'ol--zoom';
    if (active) {
        className += ' ol--active';
    }
    return (
        <div className={className}>
            <CloseButton className="ol--zoom__close" type="outline" onClick={props.onClose} />
            <div className="ol--zoom__inn">
                <div className="panzoom__cont">
                    <div className="artwork__img">
                        {content}
                    </div>
                    <div className="panzoom__controls">
                        <button id="zoomOut" className="panzoom__out" onClick={() => {
                            window.acpanzoom.instance.zoomOut();
                            document.getElementById('zoomSlider').value = window.acpanzoom.instance.getScale() + '';
                        }}>-</button>
                        <input
                            className="panzoom__slider panzoom__input"
                            id="zoomSlider"
                            max={6}
                            min={0.3}
                            step={0.05}
                            defaultValue={1}
                            type="range"
                            onInput={(event) => {
                                window.acpanzoom.instance.zoom((event.target).valueAsNumber)
                            }}
                            onChange={(event) => {
                                window.acpanzoom.instance.zoom((event.target).valueAsNumber)
                            }} />
                        <button id="zoomIn" className="panzoom__in" onClick={() => {
                            window.acpanzoom.instance.zoomIn();
                            document.getElementById('zoomSlider').value = window.acpanzoom.instance.getScale() + '';
                        }}>+</button>
                        <button className="panzoom__reset" style={{ display: 'none' }}>Reset</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

function _ZoomSlideshow(props) {
    const [dotsId, setDotsId] = useState(undefined);
    useEffect(() => {
        if (!props.blockIdentifier) {
            return;
        }
        const id = `slider--dots-${props.blockIdentifier}`;
        setDotsId(id);
    }, [props.blockIdentifier]);

    useEffect(() => {
        props.onRegisterConfigHandler((config) => {
            config.dotsContainer = `#${dotsId}`
            config.startPosition = props.startPosition
        })
    }, [dotsId])

    const _images = props.images || [];
    const sliderDots = [];
    const slides = _images.map(function (d, i) {
        sliderDots.push(<SlideshowDot key={`${i}_${d.id}-dot`} image={d} />);
        return (
            <ZoomSlide
                key={`${i}_${d.id}`}
                data={d}
                id={`imageSlide-${i}`}
                notes={props.inventory.notes}
                seoDescription={props.seoDescription}
                style={props.imageStyle} />
        );
    });
    let sliderId;
    if (dotsId) {
        sliderId = props.sliderId;
    }
    return (
        <React.Fragment>
            <div className="slider slider--full__width panzoom__parent" id={sliderId} style={props.style}>
                {slides}
            </div>
            <div id={dotsId} className="owl-dots slider__dots--full__width" style={props.style}>
                {sliderDots}
            </div>
        </React.Fragment>
    );
}
const ZoomSlideshow = withSlideshowInitialization(
    _ZoomSlideshow,
    {
        dots: true,
        items: 1,
        loop: true,
        nav: true,
        navText: false,
        responsiveClass: true,
        smartSpeed: 1000,
        onChanged: function () {
            if (window.acpanzoom.instance) {
                window.acpanzoom.instance.destroy();
            }

            window.setTimeout(function () {
                var container = document.getElementsByClassName('ol--zoom');
                if (!container || container.length == 0) {
                    return;
                }
                var activeSlide = container[0].getElementsByClassName('owl-item active')[0];
                if (activeSlide) {
                    var zoomImg = activeSlide.getElementsByClassName('panzoom__img')[0];
                    if (zoomImg) {
                        window.acpanzoom.instance = Panzoom(zoomImg);
                    }
                }
            }, 100);
        }
    }
);

function ZoomSlide(props) {
    const imageUrl = _Image.url(props.data, undefined, 1920);
    return (
        <div className="slider__slide panzoom__img">
            <div className="sect--slider__bg" style={{ filter: 'none' }}>
                <img alt={props.seoDescription}
                    caption={props.seoDescription}
                    className="imageSlide"
                    description={props.notes}
                    id={props.id}
                    src={imageUrl}
                    style={props.style}
                    title={props.seoDescription} />
            </div>
        </div>
    );
}

// #endregion ZOOM

export {
    ContentContainer,
    ImageGalleryModal,
    InventoryModal,
    Popup,
    ShareModal,
    VirtualInstallModal,
    ZoomModal
};